import { existsSync } from "fs";
import { join } from "path";
import { loadUserOneOptions } from "../vite/loadConfig";
async function run(args) {
  var _options_config_config_server, _options_config_config, _options_config;
  var root = process.cwd();
  if (!existsSync(join(root, "android"))) {
    var { run: prebuildRun } = await import("./prebuild");
    await prebuildRun({
      platform: "android"
    });
  }
  var { runAndroid } = await import("vxrn");
  var options = await loadUserOneOptions("serve", true).catch(function() {
    return null;
  });
  await runAndroid({
    root,
    port: options === null || options === void 0 ? void 0 : (_options_config = options.config) === null || _options_config === void 0 ? void 0 : (_options_config_config = _options_config.config) === null || _options_config_config === void 0 ? void 0 : (_options_config_config_server = _options_config_config.server) === null || _options_config_config_server === void 0 ? void 0 : _options_config_config_server.port
  });
}
export {
  run
};
//# sourceMappingURL=runAndroid.js.map
